import { SocietyCorporateId } from 'types/Society';

const internalFF = 'showDetails';
const newPDF = 'newPDF';
const beneficiariesTest = 'btest';
const showDev = 'show-dev';
const blockAI = 'blockAI';
const newUI = 'newUI';
const refreshStatus = 'refreshStatus';
const myriamIdpFF = 'myriam-idp-enabled';

const getFromStorage = (key) => JSON.parse(localStorage.getItem(key));

export const isPlatformAXA =
  process.env.REACT_APP_UI_CORPORATE_ID === SocietyCorporateId.AXA;
export const isPlatformASG =
  process.env.REACT_APP_DOMAIN === 'https://accionistas.axa.es';

export const isMyriamIdpEnabled =
  process.env.REACT_APP_AWS_COGNITO_MYRIAM_IDP_ENABLED === 'true';

export const hasShowDetails = () => getFromStorage(internalFF);
export const hasNewPDF = () => getFromStorage(newPDF);
export const hasBeneficiariesTest = () => getFromStorage(beneficiariesTest);
export const hasInternalView = () => getFromStorage(showDev);
export const hasBlockAI = () => getFromStorage(blockAI);
export const hasNewUI = () => getFromStorage(newUI);
export const hasRefreshStatus = () => getFromStorage(refreshStatus);

export const hasPartnersDecoupled = () => true;

export const hasMaintenanceWarning = () => false;
export const hasMaintenancePartnerBook = () => false;

const hasMyriamIdpFF = () => getFromStorage(myriamIdpFF);

export const hasMyriamIdpLogin = () =>
  isPlatformAXA && isMyriamIdpEnabled && hasMyriamIdpFF();
